import deprecations from '@procore/core-react/dist/_typedoc/deprecations.json';
import * as React from 'react';
export default {
  deprecations,
  React
};